import React from 'react'
import { ContentHeader } from '../../../../components/Header/ContentHeader'
import { IProject } from '../../types/project'
import { RootState } from '../../../../store/rootState'
import { connect } from 'react-redux'
import { useLocation } from 'react-router'
import { ICustomizedState } from '../../../../types/history'

interface StateProps {
  project: IProject
}

type Props = StateProps

const ProjectInsightsHeader = (props: Props): JSX.Element => {
  const { project } = props

  const _location = useLocation()
  const _locationState = _location.state as ICustomizedState

  return (
    <ContentHeader
      title={project.name}
      subtitle={project.customer?.name ?? project.category}
      color='#08D6A1'
      backTitle={_locationState && _locationState.from === 'dashboard' ? 'Dashboard' : 'Insights'}
      backLocation={`/projects`}
    />
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project
  }
}

export default connect(mapStateToProps, null)(ProjectInsightsHeader)
